// TODO this code would need a huge refactor and rewrite!
// This is the very wrong way to configure things
function c3GetFirebaseCurrentEnv() {
  if (self.location.hostname.includes("fatebenefratelli")) {
    if (self.location.hostname.includes("staging")) {
      return "staging-fbf";
    } else {
      return "production-fbf"; // Use production as default
    }
  } else if (self.location.hostname.includes("websanity")) {
    if (self.location.hostname.includes("test")) {
      return "testragusa";
    } else {
      return "productionragusa"; // Use production as default
    }
  } else if(self.location.hostname.includes("asst-settelaghi")) {
    return "production7laghi";
  } else if(self.location.hostname.includes("piattaformasalute")) {
    return "productionragusa";
  } else if (self.location.hostname.includes('apss')) {
    if (self.location.hostname.includes('trecdev')) {
      return 'trecdev';
    } else {
      return 'trecprod'; // Use production as default
    }
  } else if (self.location.hostname.includes('trentinosalute.net')) {
    return 'trecprod';
  } else {
    console.warn(
      "Fail to detect correct Firebase configuration for this environment. Use default. [hostname: " +
        self.location.hostname +
        "]"
    );
    return "dedadev"; // Use APSS as default
  }
}

function c3GetFirebaseConfigForCurrentEnv() {
  const env = c3GetFirebaseCurrentEnv();
  // c3FirebaseConfig should be available
  return self.c3FirebaseConfig[env] || self.c3FirebaseConfig["production-apss"];
}

// If script is used in main thread of service worker -> save config in self (i.e. window or self)
if (self) {
  // "Export" utils
  self.c3GetFirebaseConfigForCurrentEnv = c3GetFirebaseConfigForCurrentEnv;
}
